import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getRemoteConfig } from "firebase/remote-config";

const resolveFirebaseAuthDomain = () => {
  const configured = String(
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "",
  ).trim();
  if (typeof window === "undefined") return configured;

  const hostname = String(window.location.hostname || "")
    .trim()
    .toLowerCase();
  const isLocalhost =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "[::1]";
  if (isLocalhost) return configured;

  const mode = String(import.meta.env.VITE_FIREBASE_AUTH_DOMAIN_MODE || "")
    .trim()
    .toLowerCase();
  if (mode !== "same_origin") return configured;

  // Safari/iOS redirect reliability is better when authDomain matches the app origin.
  if (!configured || configured.endsWith(".firebaseapp.com")) {
    return hostname;
  }

  return configured;
};

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: resolveFirebaseAuthDomain(),
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 0;
